import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  standalone: false
})
export class CardComponent {
  @Input() label: string = '';
  @Input() value: number = 0;
  @Input() value2!: number | null;
  @Input() showDropdown: boolean = false;
  @Input() showToggle: boolean = false;
  @Input() toggleValue: boolean = false; // Initial value of toggle

  @Input() dropdownItems: { label: string, value: number }[] = [];

  @Output() toggleChanged = new EventEmitter<boolean>();
  @Output() toggleDropdown = new EventEmitter<boolean>();

  isDropdownOpen: boolean = false;

  onToggleChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.toggleChanged.emit(checked);
  }

  onDropdownToggle(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    this.toggleDropdown.emit(this.isDropdownOpen);
  }
}
